// API-Helfer für das Admin-Backend & News-Fetch
const API_BASE = "/api";

async function request(path, options = {}) {
  const url = `${API_BASE}${path}`;
  const opts = {
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  };
  const res = await fetch(url, opts);
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = { ok: false, error: "invalid_response" };
  }
  return { status: res.status, data };
}

export const api = {
  session: () => request("/session.php", { method: "GET" }),
  login: (username, password) =>
    request("/login.php", { method: "POST", body: JSON.stringify({ username, password }) }),
  logout: () => request("/logout.php", { method: "POST" }),

  // Öffentlich: nur aktive News (Zeitraum umschließt jetzt)
  getPublicNews: () => request("/news.php", { method: "GET" }),
  // Öffentlich: Team für Homepage
  getPublicTeam: () => request("/team.php", { method: "GET" }),

  // Admin CRUD
  listNews: () => request("/news-admin.php", { method: "GET" }),
  getNewsItem: (id) => request(`/news-admin.php?id=${id}`, { method: "GET" }),
  createNews: (payload) =>
    request("/news-admin.php", { method: "POST", body: JSON.stringify(payload) }),
  updateNews: (id, payload) =>
    request(`/news-admin.php?id=${id}`, { method: "PUT", body: JSON.stringify(payload) }),
  deleteNews: (id) => request(`/news-admin.php?id=${id}`, { method: "DELETE" }),
  duplicateNews: (id) =>
    request(`/news-admin.php?duplicate=${id}`, { method: "POST", body: "{}" }),

  // Benachrichtigungs-Empfänger
  listEmails: () => request("/emails.php", { method: "GET" }),
  addEmail: (email) => request("/emails.php", { method: "POST", body: JSON.stringify({ email }) }),
  deleteEmail: (id) => request(`/emails.php?id=${id}`, { method: "DELETE" }),
  sendTestMail: (to) => request("/test-mail.php", { method: "POST", body: JSON.stringify({ to }) }),

  // Team (admin only für POST/PUT/DELETE)
  createTeam: (payload) => request("/team.php", { method: "POST", body: JSON.stringify(payload) }),
  updateTeam: (id, payload) => request(`/team.php?id=${id}`, { method: "PUT", body: JSON.stringify(payload) }),
  deleteTeam: (id) => request(`/team.php?id=${id}`, { method: "DELETE" }),
  reorderTeam: (order) => request("/team.php?reorder=1", { method: "POST", body: JSON.stringify({ order }) }),
  uploadTeamImage: (dataUrl) => request("/team-upload.php", {
    method: "POST",
    body: JSON.stringify({ image_data_url: dataUrl }),
  }),

  // Benutzer-Verwaltung (admin only)
  listUsers: () => request("/users.php", { method: "GET" }),
  createUser: (payload) => request("/users.php", { method: "POST", body: JSON.stringify(payload) }),
  updateUser: (id, payload) => request(`/users.php?id=${id}`, { method: "PUT", body: JSON.stringify(payload) }),
  deleteUser: (id) => request(`/users.php?id=${id}`, { method: "DELETE" }),

  // Site-Config (kombinierter Public-Endpoint für Homepage-Perf)
  getSiteConfig: () => request("/site-config.php", { method: "GET" }),

  // Leistungen (public GET; write nur Admin)
  listServices: () => request("/services.php", { method: "GET" }),
  createService: (payload) => request("/services.php", { method: "POST", body: JSON.stringify(payload) }),
  updateService: (id, payload) => request(`/services.php?id=${id}`, { method: "PUT", body: JSON.stringify(payload) }),
  deleteService: (id) => request(`/services.php?id=${id}`, { method: "DELETE" }),
  reorderServices: (order) => request("/services.php?reorder=1", { method: "POST", body: JSON.stringify({ order }) }),

  // Sprechzeiten (public GET; write nur Admin)
  listHours: () => request("/office-hours.php", { method: "GET" }),
  createHours: (payload) => request("/office-hours.php", { method: "POST", body: JSON.stringify(payload) }),
  updateHours: (id, payload) => request(`/office-hours.php?id=${id}`, { method: "PUT", body: JSON.stringify(payload) }),
  deleteHours: (id) => request(`/office-hours.php?id=${id}`, { method: "DELETE" }),
  reorderHours: (order) => request("/office-hours.php?reorder=1", { method: "POST", body: JSON.stringify({ order }) }),

  // Kontakt-Einstellungen (Key-Value; write nur Admin, Payload = { key: value, ... })
  getSettings: () => request("/settings.php", { method: "GET" }),
  updateSettings: (payload) => request("/settings.php", { method: "PUT", body: JSON.stringify(payload) }),

  // Passwort-Reset
  resetRequest: (email) =>
    request("/reset-request.php", { method: "POST", body: JSON.stringify({ email }) }),
  resetVerify: (email, code, new_password) =>
    request("/reset-verify.php", {
      method: "POST",
      body: JSON.stringify({ email, code, new_password }),
    }),
};
